import React from 'react';

const OptionModal = ({ isOpen, onClose, title, options }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 m-4 w-full max-w-sm">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <div className="space-y-2">
          {options.map((option, index) => (
            <button
              key={index}
              onClick={option.onClick}
              className={`w-full text-left p-3 active:bg-gray-50 rounded-lg ${
                option.destructive ? 'text-red-600' : ''
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
        <div className="mt-4 pt-4">
          <button
            onClick={onClose}
            className="w-full p-3 text-center bg-gray-100 rounded-lg active:bg-gray-200"
          >
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default OptionModal;
